import type { HelpdeskRequestBucket, HelpdeskRequestRelationshipFilter } from "@repo/shared-types/helpdesk";

export type HelpdeskRequestsSearch = {
  bucket?: HelpdeskRequestBucket;
  relationship?: HelpdeskRequestRelationshipFilter;
};

const isBucket = (value: unknown): value is HelpdeskRequestBucket => value === "open" || value === "done";

const isRelationship = (value: unknown): value is HelpdeskRequestRelationshipFilter => value === "all" || value === "requested_by_me" || value === "shared_with_me";

export const helpdeskRequestsSearch = (search: Record<string, unknown>): HelpdeskRequestsSearch => ({
  bucket: isBucket(search.bucket) && search.bucket !== "open" ? search.bucket : undefined,
  relationship: isRelationship(search.relationship) && search.relationship !== "all" ? search.relationship : undefined,
});
